import { useEffect, useState } from "react";

import './PremiumField.scss'
import QRCode from 'qrcode.react'
import { translateWord ,decrypt} from "../../Util/util";
import { useRouter } from "../../../hooks/router";

export default function PremiumField({
    type,
    id,
    close,
    content_type,
    configs
}) {

    const router = useRouter()

    const _token = decrypt('token', localStorage.getItem("token"))
    const root = JSON.parse(decrypt('root', localStorage.getItem('root')))
    const root_id = JSON.parse(localStorage.getItem('root_id'))

    const [valueQR, setValueQR] = useState('')

    useEffect(() => {

        if (id) {

            const host = "http://payment.tivimivi.net:3232/#/dashboard/home?device_id=web_" + root_id + "&device_name=web&device_model=web&token="

            let url

            if (type == 'live') url = host + _token + "&channel_id=" + id

            else url = host + _token + "&movie_id=" + id

            setValueQR(url)

        }

    }, [id])


    return (
        content_type == 'live' ?
            <div className={'parent_premium_field _live '}>
                <div className="main_premium_field" onClick={close}></div>
                <div className="modal_premium_field bg_color">
                    <div className="title_premium_field">
                        <h1 className={'first_premium_field'}>This content needs Premium Account!</h1>
                        <p className="second_title_premium_field_live">Your subscription is currently inactive. Click here to reactivate your subscription or call customer service at {(configs?.contact_number || '')}.</p>
                        <p className="second_title_premium_field_live">You can upgrade subscription from Settings/Payment</p>
                        <span className="live_desc_premium">Press 'Subscribe',to go to Settings/Payment.</span>
                    </div>

                    <div className="btn_premium_field card_color" onClick={() => router.push('/settings?a=payment')}>
                        <span>{translateWord('Subscirbe')}</span>
                    </div>
                </div>
            </div>
            :
            <div className={'parent_premium_field'}>
                <div className="main_premium_field" onClick={close}></div>
                <div className="modal_premium_field">
                    <div className="title_premium_field">
                        <h1 className={'first_premium_field'}>This content needs Premium Account!</h1>
                        <h2 className="second_title_premium_field">Two ways to Subscribe</h2>
                    </div>

                    <div className="description_premium_field">
                        <div className="on_the_web">
                            <h4 className="title_on_the_web">On The Web</h4>
                            <p className="list_on_the_web">1. Go to “www.tivimivi.com/subscribe” on your mobile device or
                                computer.</p>
                            <p className="list_on_the_web">2. Login to your account</p>
                            <p className="list_on_the_web">3. Purchase Subscription</p>
                            <span className='bottom_text_premium'>When connected, this page automatically updates.</span>
                        </div>

                        <div className="middle_line">
                            <div className="line_vertical_premium"></div>
                            <p>OR</p>
                            <div className="line_vertical_premium"></div>
                        </div>

                        <div className="qr_code">
                            <h4 className="title_on_the_web">Scan QR Code</h4>
                            <p className="list_on_the_web">Use your camera app or QR code reader on your mobile device.</p>
                            <div className="QR_premium_field">
                                <QRCode value={valueQR} />
                            </div>
                            <span className='bottom_text_premium'>When connected, this page automatically updates.</span>
                        </div>

                    </div>

                    <div className="btn_premium_field card_color" onClick={close}>
                        <span>Done</span>
                    </div>
                </div>
            </div>
    )
}